import clsx from "clsx";

import styles from "./Backdrop.module.css";

export interface BackdropProps extends React.HTMLAttributes<HTMLDivElement> {
    open: boolean;
}

export const Backdrop = ({ open, className, ...rest }: BackdropProps) => (
    <div
        className={clsx(styles.root, open && styles.open, className)}
        {...rest}
    />
);
